import { useState } from 'react';
import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const PHONE_PATTERN = /^0[0-9]{9}$/;

function ProfileGate({ user, dark, onComplete }) {
  const [phone, setPhone] = useState('');
  const [birthday, setBirthday] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const c = {
    overlay: 'rgba(0,0,0,0.75)',
    card: dark ? '#1c1c1c' : '#ffffff',
    text: dark ? '#eeeeee' : '#111111',
    sub: dark ? '#999999' : '#666666',
    inp: dark ? '#252525' : '#f5f5f5',
    inpBorder: dark ? '#383838' : '#e0e0e0',
  };

  const handleSubmit = async () => {
    setError('');

    if (!phone) {
      setError('กรุณากรอกเบอร์โทรศัพท์ค่ะ');
      return;
    }
    if (!PHONE_PATTERN.test(phone)) {
      setError('กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้องค่ะ');
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${BACKEND}/save-profile`, {
        lineUserId: user.userId,
        displayName: user.displayName,
        phone,
        birthday: birthday || null,
      });
      if (res.data.success) {
        onComplete();
      } else {
        setError(res.data.message || 'บันทึกไม่สำเร็จค่ะ กรุณาลองใหม่ค่ะ');
      }
    } catch (err) {
      setError('เกิดข้อผิดพลาดค่ะ กรุณาลองใหม่ค่ะ');
    }
    setLoading(false);
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: c.overlay,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 2000, padding: '20px', fontFamily: 'Prompt,sans-serif'
    }}>
      <div style={{
        background: c.card, borderRadius: '16px', padding: '24px 20px',
        width: '100%', maxWidth: '340px'
      }}>
        <p style={{ fontSize: '16px', fontWeight: '700', color: c.text, margin: '0 0 8px', textAlign: 'center' }}>
          กรอกข้อมูลก่อนเริ่มใช้งานค่ะ
        </p>
        <p style={{ fontSize: '11.5px', color: c.sub, margin: '0 0 18px', lineHeight: 1.6, textAlign: 'center' }}>
          เพื่อความสะดวกในการดูแลออเดอร์ของคุณ กรุณากรอกข้อมูลด้านล่างค่ะ ข้อมูลของคุณจะถูกเก็บเป็นความลับและไม่เปิดเผยให้บุคคลอื่นค่ะ ทางร้านจะไม่โทรหรือส่งข้อความใดๆ ไปรบกวนค่ะ
        </p>

        <p style={{ fontSize: '11px', color: c.sub, margin: '0 0 4px' }}>เบอร์โทรศัพท์ *</p>
        <input
          value={phone}
          onChange={e => setPhone(e.target.value.replace(/[^0-9]/g, ''))}
          placeholder="08X-XXX-XXXX"
          maxLength={10}
          inputMode="numeric"
          style={{
            background: c.inp, border: `1px solid ${c.inpBorder}`, borderRadius: '8px',
            padding: '10px 12px', fontSize: '13px', color: c.text,
            fontFamily: 'Prompt,sans-serif', width: '100%', boxSizing: 'border-box', marginBottom: '14px'
          }}
        />

        <p style={{ fontSize: '11px', color: c.sub, margin: '0 0 4px' }}>วันเกิด (ไม่บังคับ)</p>
        <input
          type="date"
          value={birthday}
          onChange={e => setBirthday(e.target.value)}
          style={{
            background: c.inp, border: `1px solid ${c.inpBorder}`, borderRadius: '8px',
            padding: '10px 12px', fontSize: '13px', color: c.text,
            fontFamily: 'Prompt,sans-serif', width: '100%', boxSizing: 'border-box'
          }}
        />
        <p style={{ fontSize: '10.5px', color: '#FF4500', margin: '6px 0 0' }}>
          🎂 กรอกวันเกิดไว้ รับสิทธิพิเศษวันเกิดจากเราค่ะ
        </p>

        {error && (
          <p style={{ fontSize: '11px', color: '#f87171', margin: '12px 0 0', textAlign: 'center' }}>{error}</p>
        )}

        <button
          onClick={handleSubmit}
          disabled={loading}
          style={{
            width: '100%', marginTop: '18px', padding: '12px', border: 'none',
            borderRadius: '10px', background: '#FF4500', color: '#fff',
            fontSize: '13px', fontWeight: '700', cursor: loading ? 'default' : 'pointer',
            fontFamily: 'Prompt,sans-serif', opacity: loading ? 0.7 : 1
          }}
        >
          {loading ? 'กำลังบันทึก...' : 'บันทึกและเริ่มใช้งาน'}
        </button>
      </div>
    </div>
  );
}

export default ProfileGate;